import PropTypes from 'prop-types';
import { ContentfulImageQueryPropTypes } from '@prospectus/common/ui/ContentfulImage/propTypes';

const marketingBannerPropTypes = {
  link: PropTypes.shape({
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  theme: PropTypes.string,
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  image: PropTypes.shape(ContentfulImageQueryPropTypes).isRequired,
  detailedDescription: PropTypes.shape({
    raw: PropTypes.string,
  }),
  targetCountry: PropTypes.string,
  bannerImage: PropTypes.shape(ContentfulImageQueryPropTypes),
};

const marketingBannerDefaultProps = {
  theme: 'theme-light',
  detailedDescription: null,
  targetCountry: null,
};

const marketingPromotionPropTypes = {
  bannerByLocation: PropTypes.arrayOf(PropTypes.shape(marketingBannerPropTypes)).isRequired,
  language: PropTypes.string.isRequired,
  pages: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.bool.isRequired,
};

export {
  marketingBannerPropTypes,
  marketingBannerDefaultProps,
  marketingPromotionPropTypes,
};
